import { RadioButton, RadioButtonTrueFalse } from "Components/Form/RadioButton";
import {
  getOptions,
  getYesOrNoOptions,
} from "Components/Form/RadioButton/radioButtonUtils";
import {
  AlertDescription,
  AlertTitle,
} from "Components/TextContext/commonComponentEnums";

import { PaddedSurface } from "App/global-style";
import { ContactUsAlert } from "Components/Form/Alert";
import { NumericInput } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { VALUE_TYPE } from "Components/NumberValue";
import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { BoatProductIntroFormValues } from "./boatProductIntroInterfaces";

interface Props {
  formProps: FormikProps<Partial<BoatProductIntroFormValues>>;
  texts: any;
  lang: TextLanguage;
  showBoatNotPristine: boolean;
}

export const CommonFormElements = ({
  formProps,
  texts,
  lang,
  showBoatNotPristine,
}: Props): React.ReactElement => {
  const { getText } = TextManager;
  return (
    <PaddedSurface>
      <NumericInput
        id="coverageAmount"
        name="coverageAmount"
        label={getText("boatform.label.coverageamount")}
        hint={getText("boatform.hint.coverageamount")}
        error={getError("coverageAmount", formProps)}
        suffix={VALUE_TYPE.NOK}
        inputMode={InputMode.NUMERIC}
        large
        inputProps={{ maxLength: 20 }}
      />
      {showBoatNotPristine && (
        <>
          <RadioButtonTrueFalse
            name="boatNotPristine"
            id="boatNotPristine"
            label={getText("boatform.label.boatnotpristine")}
            options={getYesOrNoOptions(
              "boatNotPristine-yes",
              "boatNotPristine-no",
            )}
            direction="vertical"
            error={getError("boatNotPristine", formProps)}
          />
          {formProps.values.boatNotPristine === BooleanFormType.TRUE && (
            <ContactUsAlert
              title={getText(AlertTitle.CALL_US)}
              description={getText(AlertDescription.CANT_BUY_ONLINE)}
              alertId="boat-can-not-be-bBought-online"
              variant="border"
              marginBottom="32px"
            />
          )}
        </>
      )}
      <RadioButton
        name="numberOfYearsAsOwner"
        id="numberOfYearsAsOwner"
        label={getText("boatform.label.numberofyearsasowner")}
        hint={getText("boatform.hint.numberofyearsasowner")}
        options={getOptions(texts.numberOfYearsAsOwner, lang)}
        direction="vertical"
        error={getError("numberOfYearsAsOwner", formProps)}
      />
    </PaddedSurface>
  );
};
